module.exports = "<div class=wh-job-listing-result> <h3 class=wh-job-listing-result__title> <% if(Url) { %> <a href=\"<%= Url %>\"><%= Title %></a> <% } else { %> <%= Title %> <% } %> </h3> <div class=wh-job-listing-result__teaser><%= Teaser %></div> <span class=wh-job-listing-result__municipality><%= Municipality %></span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/templates/job-listing-item.html
// module id = 611
// module chunks = 64